// extracted by css-extract-rspack-plugin
export default {"separator":"A6p6WDq2Qdkr6QBJ"};